module.exports = __webpack_public_path__ + "img/icon_Radar.eb123a0e.svg";